import type {ReferenceType} from '@floating-ui/react';

import {useIsomorphicLayoutEffect} from '@packages/systems/spring-hooks';
import {useFloatingBase} from './useFloatingBase';

export type AnchorRef = ReferenceType | null;

/**
 * Dynamically updates the position of the floating element based on the anchorRef, if one is present.
 *
 * This hook is used in various floating components (e.g. `Popover`, `Tooltip`, etc.) to ensure that our positioning logic for `anchorRefs` remains consistent.
 */
export const useAnchorRefPosition = ({
  anchorRef,
  context,
}: {
  anchorRef?: AnchorRef;
  context: ReturnType<typeof useFloatingBase>['context'];
}) => {
  useIsomorphicLayoutEffect(() => {
    if (anchorRef) {
      context.refs.setPositionReference(anchorRef);
    }
  }, [anchorRef, context.refs]);
};
